// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3710":"abda976c","3979":"b197fcde"}[chunkId] + ".chunk.css";
};